let usage = `
<Pagination
  :count="count"
  :size="size"
  :current="current"
  @getCurrent="updatePage"
/>
`.slice(1);

export default {
  usage
};
